export default "__VITE_ASSET__DQF7FCRZ__"